/**
 * Small stat tile for the contact-detail at-a-glance strip.
 * Reuses the existing `.stat-card` styles.
 */
import { clsx } from "clsx";
import type { ReactNode } from "react";

export type StatDelta = "up" | "warn" | null;

export function StatTile({
  label,
  figure,
  delta,
  deltaTone = null,
}: {
  label: string;
  figure: ReactNode;
  delta?: ReactNode;
  deltaTone?: StatDelta;
}) {
  return (
    <div className="stat-card">
      <span className="label">{label}</span>
      <span className="figure">{figure}</span>
      {delta != null ? (
        <span
          className={clsx(
            "delta",
            deltaTone === "up" && "is-up",
            deltaTone === "warn" && "is-warn",
          )}
        >
          {delta}
        </span>
      ) : null}
    </div>
  );
}
